import { useFragment } from '@apollo/client';

import { useIsClient } from '@utils/common';
import { Skeleton } from '@ui/Skeleton';
import CreateComplain from '@components/CreateComplain';

import { ProductDetailsUserComplaintFragment, ProductDetailsUserComplaintFragmentDoc } from './gql/graphql.v3.generated';

type Product = {
  __typename?: 'ProductDetails',
  id: number,
}

interface Props {
  product?: Product,
}

export const UserComplaintContainer: React.FC<Props> = ({
  product,
}) => {
  const isClient = useIsClient();

  const { data, complete } = useFragment<ProductDetailsUserComplaintFragment>({
    fragment: ProductDetailsUserComplaintFragmentDoc,
    from: product || null,
  });

  if (!complete) {
    return (
      <Skeleton
        height='14px'
        width='200px'
      />
    );
  }

  if (data?.seller && isClient) {
    return (
      <CreateComplain
        username={data.seller.username}
        productId={data.id}
      />
    );
  }

  return null;
};
